import get from "lodash/get";
import {FeeType, InboundingFeeParam, ProgramParam} from "src/model/ProgramFees";
import IRCFunctionality from "src/model/IRCFunctionality";
import IPSServiceOption from "src/model/IPSServiceOption";
import {DEFAULT_INBOUNDING_FEE_PARAM, InboundingRegions} from "src/model/InboundingPlacement";

export const helpPageUrl = "/gp/help/external/GWYBC38TZGCUNRKW";

export const SELECT_YOUR_PROGRAM = "SELECT_YOUR_PROGRAM";
export const COMPARISON_GRAPH = "COMPARISON_GRAPH";
export const COMPARISON_GRAPH_BAR_HEIGHT = 520;

export const PROGRAM_NAME_OF_FBA = "Core";
export const PROGRAM_NAME_OF_MFN = "MFN";
export const PROGRAM_NAME_OF_NARF = "NARF";
export const PROGRAM_NAME_OF_GSCORE = "GSCore";
export const defaultPrograms = [PROGRAM_NAME_OF_FBA, PROGRAM_NAME_OF_MFN];
// Constants used by fee explainer widget
export const FEEEXPLAINER_LOADER_SCRIPT = "https://d16qhxcx3vgq6l.cloudfront.net/fee-explainer-tooltip-loader.js";
export const FEEEXPLAINER_CLIENT_ID = "RC";
export const IRC_FEEEXPLAINER_CLIENT_ID = "IRC";
export const FEEEXPLAINER_FORM_LONG = "long";
export const FEEEXPLAINER_FEE_REFERRAL = "referral";
export const FEEEXPLAINER_FEE_FULFILLMENT = "fulfillment";
export const FEEEXPLAINER_FEE_STORAGE = "storage"
export const FEEEXPLAINER_QUANTITY_ONE = "1";
export const SYNC_PROGRAMPARAM_EVENT_NAME = "syncProgramParam";
export const SYNC_INBOUNDINGPARAM_EVENT_NAME = "syncInboundingFeeParam";
export const SYNC_WIDGETPAGE_EVENT_NAME = "syncWidgetPage";

export const SYNC_COST_PREFERENCE_EVENT_NAME = "syncCostPreference";

export const USER_INPUT_UPDATE_DELAY_MS = 1000;

export const IMPORT_FEES_STRING_ID: string = "SC_FBA_Calc_label_ImportFees";
export const COUNTRY_CODE_SG: string = "SG";

export const IPS_UNIT_TO_INBOUND = "RC_InputLabel_Unitstoinbound";
export const IPS_FEE_PER_UNIT = "RC_Label_IPSFeePerUnit";
export const IPS_FEE_TOTAL = "RC_Label_TotalIPSFee";
export const IPS_SHIPPING_COST_PER_UNIT = "RC_Label_ShippingCostPerUnit";
export const INBOUND_CONVENIENCE_FEE = "SC_FBA_Calc_label_placement";
export const IPS_BULK_EFFECTIVE_DATE = "RC_Bulk_IPSFeeLaunchColumnText";
export const NO_TRANSLATION_COLUMNS = ["SC_FBA_Calc_report_SKU", "SC_FBA_Calc_report_FnSKU", "SC_FBA_Calc_bulk_asin",
    "SC_FBA_Calc_bulk_product_name"];

export const PROGRAM_INDEX_DELIMITER = "#";


const urlParams = new URLSearchParams(window.location.search);
export const IRCUrlProgramName = urlParams.get("programName") || urlParams.get("programname") || "";

export const shippingZoneFeeTypeMap: Record<string, FeeType> = {
    "National": FeeType.FulfillmentFee,
    "Regional": FeeType.FulfillmentFee_Regional,
    "Local": FeeType.FulfillmentFee_Local,
}

export const programMap: Record<string, string> = {
    "EURF": "EFN"
}

export const IRCIndiaProgramNameMap: Record<string, Array<string>> = {
    "UNKNOWN": ["Core", "MFN"],
    "BOTH": ["Core", "Onsite","MFN"],
    "FBA_ONLY": ["Core","MFN"],
    "SELLER_FLEX_ONLY": ["Onsite","MFN"]
}

export const shippingZoneStringIdMap: Record<string, string> = {
    "National": "NETPROCEEDSWIDET_SHIPPING_REGION_NATIONAL",
    "Regional": "NETPROCEEDSWIDET_SHIPPING_REGION_REGIONAL",
    "Local": "NETPROCEEDSWIDET_SHIPPING_REGION_LOCAL",
}

export const programNotesMap: Record<string, string> = {
    "NARF": "SC_FBA_Calc_program_narf_notes",
    "Core": "SC_FBA_Calc_program_fba_notes",
    "Uno": "SC_FBA_Calc_program_snl_notes",
    "EFN": "SC_FBA_Calc_program_efn_notes",
    "PanEU": "SC_FBA_Calc_program_paneu_notes",
    "PanEUUno": "SC_FBA_Calc_program_paneusnl_notes",
    "Onsite": "SC_FBA_Calc_program_sellerflex_notes_in",
    "EURF": "SC_FBA_Calc_program_efn_notes",
}

export const programNameMap: Record<string, string> = {
    "NARF": "SC_FBA_Calc_program_narf",
    "Core": "SC_FBA_Calc_AMZNFulfillment",
    "Uno": "SC_FBA_Calc_program_snl",
    "EFN": "SC_FBA_Calc_program_efn",
    "PanEU": "SC_FBA_Calc_program_paneu",
    "PanEUUno": "SC_FBA_Calc_program_paneusnl",
    "MFN": "SC_FBA_Calc_yourFulfillment",
    "Onsite": "NETPROCEEDSWIDGET_SF_TOGGLE_SELLER_FLEX",
    "EURF": "SC_FBA_Calc_program_efn", //EURF is internal code name. Display EFN name to seller.
    "GSCore": "SC_FBA_Calc_program_gs_fba",
}

export const programBenefitsMap: Record<string, Array<string>> = {
    "NARF": [
        "SC_FBA_Calc_program_narf_benefits1",
        "SC_FBA_Calc_program_narf_benefits2",
        "SC_FBA_Calc_program_narf_benefits3"
    ],
    "Core": [
        "SC_FBA_Calc_program_fba_benefits1",
        "SC_FBA_Calc_program_fba_benefits2",
        "SC_FBA_Calc_program_fba_benefits3",
        "SC_FBA_Calc_program_fba_benefits4"
    ],
    "Uno": [
        "SC_FBA_Calc_program_snl_benefits1",
        "SC_FBA_Calc_program_snl_benefits2",
        "SC_FBA_Calc_program_snl_benefits3"
    ],
    "EFN": [
        "SC_FBA_Calc_program_efn_benefits1",
        "SC_FBA_Calc_program_efn_benefits2"
    ],
    "EURF": [
        "SC_FBA_Calc_program_efn_benefits1",
        "SC_FBA_Calc_program_efn_benefits2"
    ],
    "PanEU": [
        "SC_FBA_Calc_program_paneu_benefits1",
        "SC_FBA_Calc_program_paneu_benefits2",
        "SC_FBA_Calc_program_paneu_benefits3",
    ],
    "PanEUUno": [
        "SC_FBA_Calc_program_paneusnl_benefits1",
        "SC_FBA_Calc_program_paneusnl_benefits2",
        "SC_FBA_Calc_program_paneusnl_benefits3",
        "SC_FBA_Calc_program_paneusnl_benefits4"
    ]
}
export const loginProgramHelpLinkMap: Record<string, Record<string, string>> = {
    "Uno": {
        "GB": "https://sellercentral.amazon.co.uk/fba/programs/snl/about",
        "DE": "https://sellercentral.amazon.de/fba/programs/snl/about",
        "FR": "https://sellercentral.amazon.fr/fba/programs/snl/about",
        "IT": "https://sellercentral.amazon.it/fba/programs/snl/about",
        "ES": "https://sellercentral.amazon.es/fba/programs/snl/about",
        "JP": "https://sellercentral.amazon.co.jp/fba/programs/snl/about",
        "US": "https://sellercentral.amazon.com/fba/programs/snl/about"
    },
    "PanEUUno": {
        "DE": "https://sellercentral.amazon.de/fba/programs/snl/paneu",
        "FR": "https://sellercentral.amazon.fr/fba/programs/snl/paneu",
        "IT": "https://sellercentral.amazon.it/fba/programs/snl/paneu",
        "ES": "https://sellercentral.amazon.es/fba/programs/snl/paneu"
    },
    "PanEU": {
        "ALL": "https://sell.amazon.co.uk/fulfilment-by-amazon/fba-europe"
    },
    "MFN": {
        "ALL": "https://sell.amazon.com/learn/ecommerce-fulfillment"
    },
    "Core": {
        "ALL": "https://sell.amazon.com/fulfillment-by-amazon"
    },
    "CEE": {
        "DE": "https://sellercentral-europe.amazon.com/help/hub/reference/G202030150"
    },
    "NARF": {
        "ALL": "https://sellercentral.amazon.com/gp/help/help.html?itemID=G5P3CDUHZWSZLXLB"
    },
    "EFN": {
        "ALL": "https://sellercentral.amazon.co.uk/gp/help/external/201606080"
    },
    "Onsite": {
        "IN": "https://www.sellercentral.amazon.dev/help/hub/reference/G202068160"
    },
    "EURF":{
        "TR": "https://www.sellercentral.amazon.dev/help/hub/reference/GZPT8XN3YNMRXFEZ",
        "GB": "https://sellercentral.amazon.co.uk/gp/help/external/201606080"
    }
}

export const nonLoginProgramHelpLinkMap: Record<string, Record<string, string>> = {
    "Uno": {
        "GB": "https://sell.amazon.co.uk/fulfilment-by-amazon/fba-small-and-light",
        "DE": "https://sell.amazon.de/versand-durch-amazon/small-and-light",
        "FR": "https://sell.amazon.fr/expedie-par-amazon/petit-et-leger",
        "IT": "https://sell.amazon.it/logistica-di-amazon/small-and-light",
        "ES": "https://sell.amazon.es/logistica-de-amazon/pequeno-y-ligero",
        "JP": "https://sell.amazon.co.jp/fulfill/fulfillment-by-amazon/small-and-light?ref_=asjp_soa_rd&",
        "US": "https://sell.amazon.com/fulfillment-by-amazon/fba-small-and-light"
    },
    "PanEUUno": {
        "DE": "https://sell.amazon.com/fulfillment-by-amazon",
        "FR": "https://sell.amazon.com/fulfillment-by-amazon",
        "IT": "https://sell.amazon.com/fulfillment-by-amazon",
        "ES": "https://sell.amazon.com/fulfillment-by-amazon"
    },
    "PanEU": {
        "DE": "https://sell.amazon.co.uk/fulfilment-by-amazon/fba-europe",
        "FR": "https://sell.amazon.co.uk/fulfilment-by-amazon/fba-europe",
        "IT": "https://sell.amazon.co.uk/fulfilment-by-amazon/fba-europe",
        "ES": "https://sell.amazon.co.uk/fulfilment-by-amazon/fba-europe"
    },
    "MFN": {
        "ALL": "https://sell.amazon.com/learn/ecommerce-fulfillment"
    },
    "Core": {
        "ALL": "https://sell.amazon.com/fulfillment-by-amazon"
    },
    "CEE": {
        "DE": "https://sell.amazon.de/versand-durch-amazon/central-europe-program "
    },
    "NARF": {
        "ALL": "https://sellercentral.amazon.com/gp/help/help.html?itemID=G5P3CDUHZWSZLXLB"
    },
    "EFN": {
        "ALL": "https://sellercentral.amazon.co.uk/gp/help/external/201606080"
    }
}

export const RECOMMENDATION_FBA = "FBA_CREATE_SHIPMENT";
export const RECOMMENDATION_LOWASP = "LOW_ASP_DISCOUNT";

export const programWithInventoryAndStoreParam: Array<string> = [
    "NARF",
    "EFN",
    "EFN_CEE",
    "EFNUno",
    "EFNUno_CEE",
    "PanEU",
    "PanEU_CEE",
    "PanEUUno",
    "PanEUUno_CEE",
    "EURF",
    "EURF_CEE",
    "EURFUno",
    "EURFUno_CEE"
]

export const programWithFxRateParam: Array<string> = [
    "GSCore",
]

export const gsCoreCountryToInventoryMarketplaceMap: Record<string, Array<string>> = {
    "IN" : [
        "KR",
        "CN",
        "US"
    ]
}

export const programWithCeeParam: Array<string> = [
    "Core",
    "Uno",
    "EFN",
    "EFN_CEE",
    "EFNUno",
    "EFNUno_CEE",
    "PanEU",
    "PanEU_CEE",
    "PanEUUno",
    "PanEUUno_CEE",
    "EURF",
    "EURF_CEE",
    "EURFUno",
    "EURFUno_CEE"
]

export const isLoginMap: Record<string, boolean> = {
    "true": true,
    "false": false
}

export const isWidgetMap: Record<string, boolean> = {
    "true": true,
    "false": false
}

export function isLoginMode(): boolean {
    return isLoginMap["false"]!;
}

export function isWidget(): boolean {
    return isWidgetMap["false"]!;
}

export const isSurchargeMarketplaceMap: Record<string, boolean> = {
    "US": true,
    "GB": true,
    "DE": true,
    "FR": true,
    "IT": true,
    "ES": true,
    "CA": true
}

export const surchargeBannerStringIDMap: Record<string, string> = {
    "US": "SC_FBA_Calc_Fuel_Surcharge_Banner",
    "GB": "SC_FBA_Calc_Fuel_Surcharge_Banner_EU5",
    "DE": "SC_FBA_Calc_Fuel_Surcharge_Banner_EU5",
    "FR": "SC_FBA_Calc_Fuel_Surcharge_Banner_EU5",
    "IT": "SC_FBA_Calc_Fuel_Surcharge_Banner_EU5",
    "ES": "SC_FBA_Calc_Fuel_Surcharge_Banner_EU5",
    "CA": "2022_CA_Referral_Fee_and_FBA_Fee_Change"
}

export const peakFeeBannerStringIDMap: Record<string, string> = {
    "US": "SC_FBA_Calc_Peak_Fee_Banner_US_FBA_RevCalculator_NetProceedsWidget_FeeReport_1",
    "CA": "SC_FBA_Calc_Peak_Fee_Banner_CA_FBA_RevCalculator_NetProceedsWidget_FeeReport_1"
}

export const peakFeeHelpStringIDMap: Record<string, string> = {
    "US": "SC_FBA_Calc_Peak_Fee_Banner_Help_Page_Link_US_FBA_1",
    "CA": "SC_FBA_Calc_Peak_Fee_Banner_Help_Page_Link_CA_FBA_1"
}

export const surchargeDateStringIDMap: Record<string, string> = {
    "US": "SC_FBA_Calc_Fuel_Surcharge_Banner_4282022_Date",
    "GB": "SC_FBA_Calc_Fuel_Surcharge_Banner_05122022_Date",
    "DE": "SC_FBA_Calc_Fuel_Surcharge_Banner_05122022_Date",
    "FR": "SC_FBA_Calc_Fuel_Surcharge_Banner_05122022_Date",
    "IT": "SC_FBA_Calc_Fuel_Surcharge_Banner_05122022_Date",
    "ES": "SC_FBA_Calc_Fuel_Surcharge_Banner_05122022_Date"
}

export const surchargeRateMap: Record<string, number> = {
    "US": 0.05,
    "GB": 0.043,
    "DE": 0.043,
    "FR": 0.043,
    "IT": 0.043,
    "ES": 0.043
}

export const surchargeHelpPageLinkStringIDMap: Record<string, string> = {
    "US": "SC_FBA_Calc_Fuel_Surcharge_Banner_Help_Page_Link",
    "GB": "SC_FBA_Calc_Fuel_Surcharge_Banner_Help_Page_Link_EU5",
    "DE": "SC_FBA_Calc_Fuel_Surcharge_Banner_Help_Page_Link_EU5",
    "FR": "SC_FBA_Calc_Fuel_Surcharge_Banner_Help_Page_Link_EU5",
    "IT": "SC_FBA_Calc_Fuel_Surcharge_Banner_Help_Page_Link_EU5",
    "ES": "SC_FBA_Calc_Fuel_Surcharge_Banner_Help_Page_Link_EU5",
    "CA": "SC_FBA_Calc_Fuel_Surcharge_Banner_Help_Page_Link_CA"
}

export const surchargeHelpPageLinkMap: Record<string, string> = {
    "US": "https://sellercentral.amazon.com/help/hub/reference/GABBX6GZPA8MSZGW?ref_=revecalc",
    "GB": "https://sellercentral.amazon.co.uk/help/hub/reference/G4CY52GG5GXKUD5S?ref_=revecalc",
    "DE": "https://sellercentral.amazon.de/help/hub/reference/G4CY52GG5GXKUD5S?ref_=revecalc",
    "FR": "https://sellercentral.amazon.fr/help/hub/reference/G4CY52GG5GXKUD5S?ref_=revecalc",
    "IT": "https://sellercentral.amazon.it/help/hub/reference/G4CY52GG5GXKUD5S?ref_=revecalc",
    "ES": "https://sellercentral.amazon.es/help/hub/reference/G4CY52GG5GXKUD5S?ref_=revecalc",
    "CA": "https://sellercentral.amazon.ca/help/hub/reference/GABBX6GZPA8MSZGW?ref_=revecalc"
}

export const countryMap: Record<string, Array<string>> = {
    "USAmazon": [
        "US",
        "CA",
        "MX",
        "BR"
    ],
    "EUAmazon": [
        "GB",
        "DE",
        "FR",
        "IT",
        "ES",
        "IN",
        "AE",
        "TR",
        "SA",
        "NL",
        "SE",
        "PL",
        "EG",
        "BE",
        "ZA",
    ],
    "JPAmazon": [
        "JP",
        "AU",
        "SG"
    ]
};

export const programAmazonStoreMap: Record<string, Array<string>> = {
    "NARF": [
        "CA",
        "MX",
        "BR"
    ],
    "EFN": [
        "GB",
        "DE",
        "FR",
        "IT",
        "ES",
        "NL",
        "SE",
        "PL",
        "BE",
        "TR"
    ],
    "PanEU": [
        "DE",
        "FR",
        "IT",
        "ES",
        "NL",
        "SE",
        "PL",
        "BE",
    ],
    "EFNUno": [
        "DE",
        "FR",
        "IT",
        "ES",
    ],
    "PanEUUno": [
        "DE",
        "FR",
        "IT",
        "ES",
    ],
    "EURF": [
        "TR",
        "GB",
        "DE",
        "FR",
        "IT",
        "ES",
        "NL",
        "SE",
        "PL",
        "BE",
    ],
};

export const programInventoryMap: Record<string, Array<string>> = {
    "NARF": [
        "US"
    ],
    "EFN": [
        "DE",
        "FR",
        "IT",
        "ES",
        "NL",
        "SE",
        "PL",
        "CZ",
        "BE",
        "GB",
    ],
    //TODO: now only TR use EURF program in backend. This is short term solution. Long term solution is getting inventory from response
    "EURF": [
        "DE",
        "FR",
        "IT",
        "ES",
    ],
    "PanEU": [
        "DE",
        "FR",
        "IT",
        "ES",
        "NL",
        "SE",
        "PL",
        "CZ",
        "BE",
    ],
    "EFNUno": [
        "DE",
        "FR",
        "IT",
        "ES",
        "PL",
        "CZ",
    ],
    "PanEUUno": [
        "DE",
        "FR",
        "IT",
        "ES",
        "PL",
        "CZ",
    ]
};

export const countryFBAProgramRankMap: Record<string, Record<string, number>> = {
    "US": {
        "Uno": 1,
        "Core": 2
    },
    "CA": {
        "Core": 1
    },
    "MX": {
        "Core": 1
    },
    "BR": {
        "Core": 1
    },
    "GB": {
        "Uno": 1,
        "Core": 2
    },
    "DE": {
        "PanEUUno": 1,
        "Uno": 2,
        "PanEU": 3,
        "Core": 4
    },
    "FR": {
        "PanEUUno": 1,
        "Uno": 2,
        "PanEU": 3,
        "Core": 4
    },
    "IT": {
        "PanEUUno": 1,
        "Uno": 2,
        "PanEU": 3,
        "Core": 4
    },
    "ES": {
        "PanEUUno": 1,
        "Uno": 2,
        "PanEU": 3,
        "Core": 4
    },
    "NL": {
        "PanEU": 1,
        "Core": 2
    },
    "PL": {
        "PanEU": 1,
        "Core": 2
    },
    "SE": {
        "PanEU": 1,
        "Core": 2
    },
    "BE": {
        "PanEU": 1,
        "Core": 2
    },
    "ZA": {
        "Core": 1
    },
    "TR": {
        "Core": 1
    },
    "IN": {
        "Core": 1
    },
    "JP": {
        "Uno": 1,
        "Core": 2
    },
    "AE": {
        "Core": 1
    },
    "SA": {
        "Core": 1
    },
    "EG": {
        "Core": 1
    },
    "AU": {
        "Core": 1
    },
    "SG": {
        "Core": 1
    }
};
export const countryProgramList: Record<string, Array<string>> = {
    "US": ["MFN", "Core"],
    "CA": ["MFN", "Core", "NARF"],
    "MX": ["MFN", "Core", "NARF"],
    "BR": ["MFN", "Core", "NARF"],
    "GB": ["MFN", "Core", "EFN"],
    "DE": ["MFN", "Core", "EFN", "PanEU", "PanEUUno"],
    "FR": ["MFN", "Core", "EFN", "PanEU", "PanEUUno"],
    "IT": ["MFN", "Core", "EFN", "PanEU", "PanEUUno"],
    "ES": ["MFN", "Core", "EFN", "PanEU", "PanEUUno"],
    "IN": ["MFN", "Core", "GSCore"],
    "AE": ["MFN", "Core"],
    "TR": ["MFN", "Core", "EFN"],
    "SA": ["MFN", "Core"],
    "NL": ["MFN", "Core", "EFN", "PanEU"],
    "SE": ["MFN", "Core", "EFN", "PanEU"],
    "PL": ["MFN", "Core", "EFN", "PanEU"],
    "EG": ["MFN", "Core"],
    "BE": ["MFN", "Core", "EFN", "PanEU"],
    "ZA": ["MFN", "Core"],
    "JP": ["MFN", "Core", "Uno"],
    "AU": ["MFN", "Core"],
    "SG": ["MFN", "Core"],
}

export enum GraphBucketType {
    Revenue = 'Revenue',
    Cost = 'Cost',
    Profit = 'Profit',
}
export const graphBucketTitleStringIDMap: Record<GraphBucketType, string> = {
    Revenue: "SC_FBA_Calc_graph_subtitle_rev",
    Cost: "SC_FBA_Calc_cost",
    Profit: "SC_FBA_Calc_graph_netProfit_new",
}

export const graphBucketSubTitleStringIDMap: Record<GraphBucketType, string> = {
    Revenue: "SC_FBA_Calc_graph_revDesc",
    Cost: "SC_FBA_Calc_cost_desc",
    Profit: "SC_FBA_Calc_graph_MarginImpDef",
}

export const bulkProgramName: Record<string, Array<string>> = {
    "Core": ["SC_FBA_Calc_AMZNFulfillment"],
    "MFN": ["SC_FBA_Calc_yourFulfillment"],
    "NARF": ["SC_FBA_Calc_program_narf"],
    "Uno": ["SC_FBA_Calc_program_snl"],
    "EFN": ["SC_FBA_Calc_program_efn"],
    "PanEU": ["SC_FBA_Calc_program_paneu"],
    "PanEUUno": ["SC_FBA_Calc_program_paneusnl"],
    "GSCore": ["SC_FBA_Calc_program_gs_fba"]
}

export const taxInclusiveCountryCodeSet: Set<String> = new Set<String>(['IN'])
export const noTaxLinkCountryCodeSet: Set<String> = new Set<String>(['JP', 'MX', 'BR'])
export const lowInventoryLevelFeeCountryCodeSet: Set<String> = new Set<String>(['US', 'CA', 'DE', 'ES', 'FR', 'IT', 'JP'])
export const otherCostsInputFilter: Set<string> = new Set<string>(['miscellaneousCost', 'costOfGoodsSold'])
export const storageCostsInputFilter: Set<string> = new Set<string>(['storageCostPerUnit', 'averageInventoryUnitsStored', 'estimatedMonthlyUnitsSold'])
export const shippingToAmazonInputFilter: Set<string> = new Set<string>(['shippingToAmazon']);

export function isTaxInclusiveCountry(countryCode: string): boolean {
    return taxInclusiveCountryCodeSet.has(countryCode);
}

export function isTaxLinkShouldBeDisplayed(countryCode: string): boolean {
    return !noTaxLinkCountryCodeSet.has(countryCode);
}

export function isLowInventoryLevelFeeCountry(countryCode: string): boolean {
    return lowInventoryLevelFeeCountryCodeSet.has(countryCode);
}

export function hasRecommendationRank(countryCode: string, programName: string): boolean {
    return countryFBAProgramRankMap[countryCode] && countryFBAProgramRankMap[countryCode][programName] != undefined;
}

export function getRecommendationRank(countryCode: string, programName: string): number {
    return countryFBAProgramRankMap[countryCode][programName];
}

export const sellerCentralFeedbackHMDIdMap: Record<string, Record<string, string>> = {
    "test": {
        "USAmazon": "20111738uSeYKMXS3ijwR7OOskqRw",
        "EUAmazon": "2011200u/7iLbEfR2yHeHRnNp9h4w",
        "JPAmazon": "2011200oaLeCiB9QICXgHiyNRbAaQ"
    },
    "master": {
        "USAmazon": "2011193sHIexo8qTQqQXv5AljWENQ",
        "EUAmazon": "2011200kWRZ77ZJSzaHk8ZD350FMA",
        "JPAmazon": "2011200sSqxx+bfSQKIMnbH7G2htA"
    },
    "prod": {
        "USAmazon": "2011193sHIexo8qTQqQXv5AljWENQ",
        "EUAmazon": "2011200kWRZ77ZJSzaHk8ZD350FMA",
        "JPAmazon": "2011200sSqxx+bfSQKIMnbH7G2htA"
    }
};

export const countryDimensionUnitAbbrMap: Record<string, string> = {
    "US": "in"
};

export const dimensionUnitAbbrMap: Record<string, string> = {
    "in": "inches",
    "cm": "centimeters"
};

export const weightUnitAbbrMap: Record<string, string> = {
    "lb": "pounds",
    "kg": "kilograms"
};

export const countryWeightUnitAbbrMap: Record<string, string> = {
    "US": "lb"
};

export const countryWeightUnitMap: Record<string, string> = {
    "US": "pounds"
};

export const countryCurrencySymbolMap: Record<string, string> = {
    "US": "$",
    "CA": "$",
    "MX": "$",
    "BR": "R$",
    "GB": "£",
    "DE": "€",
    "FR": "€",
    "IT": "€",
    "ES": "€",
    "IN": "₹",
    "AE": "د.إ",
    "TR": "₺",
    "SA": "ر.س",
    "NL": "€",
    "SE": "kr",
    "PL": "zł",
    "EG": "£",
    "BE": "€",
    "ZA": "R",
    "JP": "¥",
    "AU": "$",
    "SG": "$",
    "KR": "₩",
    "CN": "¥",
};

export const countryCurrencyUnitMap: Record<string, string> = {
    "US": "USD",
    "CA": "CAD",
    "MX": "MXN",
    "BR": "BRL",
    "GB": "GBP",
    "DE": "EUR",
    "FR": "EUR",
    "IT": "EUR",
    "ES": "EUR",
    "IN": "INR",
    "AE": "AED",
    "TR": "TRY",
    "SA": "SAR",
    "NL": "EUR",
    "SE": "SEK",
    "PL": "PLN",
    "EG": "EGP",
    "BE": "EUR",
    "ZA": "ZAR",
    "JP": "JPY",
    "AU": "AUD",
    "SG": "SGD",
    "KR": "KRW",
    "CN": "CNY",
};

export const countryLocaleMap: Record<string, string> = {
    "US": "en_US",
    "CA": "en_CA",
    "MX": "es_MX",
    "BR": "pt_BR",
    "GB": "en_GB",
    "DE": "de_DE",
    "FR": "fr_FR",
    "IT": "it_IT",
    "ES": "es_ES",
    "IN": "en_IN",
    "AE": "en_AE",
    "TR": "tr_TR",
    "SA": "en_SA",
    "NL": "nl_NL",
    "SE": "sv_SE",
    "PL": "pl_PL",
    "EG": "en_EG",
    "BE": "fr_BE",
    "ZA": "en_ZA",
    "JP": "ja_JP",
    "AU": "en_AU",
    "SG": "en_SG",
};

export const vatRateMap: Record<string, number> = {
    "DE": 19,
    "ES": 21,
    "FR": 20,
    "IT": 22,
    "GB": 20,
    "NL": 21,
    "PL": 23,
    "SE": 25,
    "BE": 21,
};

export const ircFunctionalityConfigMap: Record<IRCFunctionality, Array<string>> = {
    SET_AS_DEFAULT: [
        '',
        'MYI'
    ]
}

export const feeHelpPageMap: Record<string, Record<string, string>> = {
    "ReferralFee": {
        "US": "https://sellercentral.amazon.com/help/hub/reference/GTG4BAWSY39Z98Z3?ref_=revecalc",
        "CA": "https://sellercentral.amazon.ca/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "MX": "https://sellercentral.amazon.com.mx/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "BR": "https://sellercentral.amazon.com.br/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "GB": "https://sellercentral.amazon.co.uk/gp/help/help.html/?itemID=H78LW99F4XF3Z38&ref_=revecalc",
        "DE": "https://sellercentral.amazon.de/gp/help/help.html/?itemID=GYND54PM5WB84UM&ref_=revecalc",
        "FR": "https://sellercentral.amazon.fr/gp/help/help.html/?itemID=F9K4BWLZXRPC62U&ref_=revecalc",
        "IT": "https://sellercentral.amazon.it/gp/help/help.html/?itemID=TM7BFLLKEA8T7C4&ref_=revecalc",
        "ES": "https://sellercentral.amazon.es/gp/help/help.html/?itemID=CZC4GX2L32EKP6F&ref_=revecalc",
        "IN": "https://sellercentral.amazon.in/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "AE": "https://sellercentral.amazon.ae/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "TR": "https://sellercentral.amazon.com.tr/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "SA": "https://sellercentral.amazon.sa/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "NL": "https://sellercentral.amazon.nl/gp/help/help.html/?itemID=UMBCNJPHD3UV47Q&ref_=revecalc",
        "SE": "https://sellercentral.amazon.se/gp/help/help.html/?itemID=MQ6PTDCN6ZAVA55&ref_=revecalc",
        "PL": "https://sellercentral.amazon.pl/gp/help/help.html/?itemID=8DGDDVY6WEJ522N&ref_=revecalc",
        "EG": "https://sellercentral.amazon.eg/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "BE": "https://sellercentral.amazon.com.be/gp/help/help.html/?itemID=GKYSFTZ5R8JMAHNV&ref_=revecalc",
        "ZA": "https://sellercentral.amazon.co.za/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "JP": "https://sellercentral-japan.amazon.com/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "AU": "https://sellercentral.amazon.com.au/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "SG": "https://sellercentral.amazon.sg/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
    },
    "FixedClosingFee": {
        "US": "https://sellercentral.amazon.com/help/hub/reference/G8TPCFJRDFPKAZ6M?ref_=revecalc",
        "CA": "https://sellercentral.amazon.ca/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "MX": "https://sellercentral.amazon.com.mx/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "BR": "https://sellercentral.amazon.com.br/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "GB": "https://sellercentral.amazon.co.uk/gp/help/help.html/?itemID=H78LW99F4XF3Z38&ref_=revecalc",
        "DE": "https://sellercentral.amazon.de/gp/help/help.html/?itemID=GYND54PM5WB84UM&ref_=revecalc",
        "FR": "https://sellercentral.amazon.fr/gp/help/help.html/?itemID=F9K4BWLZXRPC62U&ref_=revecalc",
        "IT": "https://sellercentral.amazon.it/gp/help/help.html/?itemID=TM7BFLLKEA8T7C4&ref_=revecalc",
        "ES": "https://sellercentral.amazon.es/gp/help/help.html/?itemID=CZC4GX2L32EKP6F&ref_=revecalc",
        "IN": "https://sellercentral.amazon.in/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "AE": "https://sellercentral.amazon.ae/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "TR": "https://sellercentral.amazon.com.tr/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "SA": "https://sellercentral.amazon.sa/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "NL": "https://sellercentral.amazon.nl/gp/help/help.html/?itemID=UMBCNJPHD3UV47Q&ref_=revecalc",
        "SE": "https://sellercentral.amazon.se/gp/help/help.html/?itemID=MQ6PTDCN6ZAVA55&ref_=revecalc",
        "PL": "https://sellercentral.amazon.pl/gp/help/help.html/?itemID=8DGDDVY6WEJ522N&ref_=revecalc",
        "EG": "https://sellercentral.amazon.eg/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "BE": "https://sellercentral.amazon.com.be/gp/help/help.html/?itemID=GKYSFTZ5R8JMAHNV&ref_=revecalc",
        "ZA": "https://sellercentral.amazon.co.za/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "JP": "https://sellercentral-japan.amazon.com/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "AU": "https://sellercentral.amazon.com.au/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "SG": "https://sellercentral.amazon.sg/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
    },
    "VariableClosingFee": {
        "US": "https://sellercentral.amazon.com/help/hub/reference/GKD9U5REK5DKB38Y?ref_=revecalc",
        "CA": "https://sellercentral.amazon.ca/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "MX": "https://sellercentral.amazon.com.mx/gp/help/help.html/?itemID=G201535680&ref_=revecalc",
        "BR": "https://sellercentral.amazon.com.br/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "GB": "https://sellercentral.amazon.co.uk/gp/help/help.html/?itemID=H78LW99F4XF3Z38&ref_=revecalc",
        "DE": "https://sellercentral.amazon.de/gp/help/help.html/?itemID=GYND54PM5WB84UM&ref_=revecalc",
        "FR": "https://sellercentral.amazon.fr/gp/help/help.html/?itemID=F9K4BWLZXRPC62U&ref_=revecalc",
        "IT": "https://sellercentral.amazon.it/gp/help/help.html/?itemID=TM7BFLLKEA8T7C4&ref_=revecalc",
        "ES": "https://sellercentral.amazon.es/gp/help/help.html/?itemID=CZC4GX2L32EKP6F&ref_=revecalc",
        "IN": "https://sellercentral.amazon.in/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "AE": "https://sellercentral.amazon.ae/gp/help/help.html/?itemID=G201115050&ref_=revecalc",
        "TR": "https://sellercentral.amazon.com.tr/gp/help/help.html/?itemID=G201115050&ref_=revecalc",
        "SA": "https://sellercentral.amazon.sa/gp/help/help.html/?itemID=201631600&ref_=revecalc",
        "NL": "https://sellercentral.amazon.nl/gp/help/help.html/?itemID=UMBCNJPHD3UV47Q&ref_=revecalc",
        "SE": "https://sellercentral.amazon.se/gp/help/help.html/?itemID=MQ6PTDCN6ZAVA55&ref_=revecalc",
        "PL": "https://sellercentral.amazon.pl/gp/help/help.html/?itemID=8DGDDVY6WEJ522N&ref_=revecalc",
        "EG": "https://sellercentral.amazon.eg/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "BE": "https://sellercentral.amazon.com.be/gp/help/help.html/?itemID=GKYSFTZ5R8JMAHNV&ref_=revecalc",
        "ZA": "https://sellercentral.amazon.co.za/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "JP": "https://sellercentral-japan.amazon.com/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "AU": "https://sellercentral.amazon.com.au/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
        "SG": "https://sellercentral.amazon.sg/gp/help/help.html/?itemID=G200336920&ref_=revecalc",
    },
    "DigitalServicesFee" : {

    },
    "FulfillmentFee": {
        "US": "https://sellercentral.amazon.com/help/hub/reference/GPDC3KPYAGDTVDJP?ref_=revecalc",
        "CA": "https://sellercentral.amazon.ca/gp/help/help.html/?itemID=G201112670&ref_=revecalc",
        "MX": "https://sellercentral.amazon.com.mx/gp/help/help.html/?itemID=G200209150&ref_=revecalc",
        "BR": "https://sellercentral.amazon.com.br/gp/help/help.html/?itemID=G200209150&ref_=revecalc",
        "GB": "https://sellercentral.amazon.co.uk/gp/help/help.html/?itemID=G200209150&ref_=revecalc",
        "DE": "https://sellercentral.amazon.de/gp/help/help.html/?itemID=G200209150&ref_=revecalc",
        "FR": "https://sellercentral.amazon.fr/gp/help/help.html/?itemID=G200209150&ref_=revecalc",
        "IT": "https://sellercentral.amazon.it/gp/help/help.html/?itemID=G200209150&ref_=revecalc",
        "ES": "https://sellercentral.amazon.es/gp/help/help.html/?itemID=G200209150&ref_=revecalc",
        "IN": "https://sellercentral.amazon.in/gp/help/help.html/?itemID=G200209150&ref_=revecalc",
        "AE": "https://sellercentral.amazon.ae/gp/help/help.html/?itemID=G200209150&ref_=revecalc",
        "TR": "https://sellercentral.amazon.com.tr/gp/help/help.html/?itemID=G200209150&ref_=revecalc",
        "SA": "https://sellercentral.amazon.sa/gp/help/help.html/?itemID=G200209150&ref_=revecalc",
        "NL": "https://sellercentral.amazon.nl/gp/help/help.html/?itemID=G200209150&ref_=revecalc",
        "SE": "https://sellercentral.amazon.se/gp/help/help.html/?itemID=G200209150&ref_=revecalc",
        "PL": "https://sellercentral.amazon.pl/gp/help/help.html/?itemID=G200209150&ref_=revecalc",
        "EG": "https://sellercentral.amazon.eg/gp/help/help.html/?itemID=G200209150&ref_=revecalc",
        "BE": "https://sellercentral.amazon.com.be/gp/help/help.html/?itemID=G200209150&ref_=revecalc",
        "ZA": "https://sellercentral.amazon.co.za/gp/help/help.html/?itemID=G200209150&ref_=revecalc",
        "JP": "https://sellercentral-japan.amazon.com/gp/help/help.html/?itemID=201112670&ref_=revecalc",
        "AU": "https://sellercentral.amazon.com.au/gp/help/help.html/?itemID=201112670&ref_=revecalc",
        "SG": "https://sellercentral.amazon.sg/gp/help/help.html/?itemID=201112670&ref_=revecalc",
    },
    "LowInventoryLevelSurcharge" : {
        "US": "https://sellercentral.amazon.com/help/hub/reference/GV43F6S76Y9DHYRH?ref_=revecalc",
        "CA": "https://sellercentral.amazon.ca/gp/help/help.html/?itemID=GV43F6S76Y9DHYRH?ref_=revecalc",
        "DE": "https://sellercentral.amazon.de/gp/help/help.html/?itemID=GV43F6S76Y9DHYRH?ref_=revecalc",
        "ES": "https://sellercentral.amazon.es/gp/help/help.html/?itemID=GV43F6S76Y9DHYRH?ref_=revecalc",
        "FR": "https://sellercentral.amazon.fr/gp/help/help.html/?itemID=GV43F6S76Y9DHYRH?ref_=revecalc",
        "IT": "https://sellercentral.amazon.it/gp/help/help.html/?itemID=GV43F6S76Y9DHYRH?ref_=revecalc",
        "JP": "https://sellercentral-japan.amazon.com/gp/help/help.html/?itemID=GV43F6S76Y9DHYRH?ref_=revecalc"
    },
    "ImportFees" : {
        // Add SG Help Page in future CR
    },
    "MonthlyStorageFee": {
        "US": "https://sellercentral.amazon.com/help/hub/reference/G3EDYEF6KUCFQTNM?ref_=revecalc",
        "CA": "https://sellercentral.amazon.ca/gp/help/help.html/?itemID=200612770&ref_=revecalc",
        "MX": "https://sellercentral.amazon.com.mx/gp/help/help.html/?itemID=200612770&ref_=revecalc",
        "BR": "https://sellercentral.amazon.com.br/gp/help/help.html/?itemID=200612770&ref_=revecalc",
        "GB": "https://sellercentral.amazon.co.uk/gp/help/help.html/?itemID=200612770&ref_=revecalc",
        "DE": "https://sellercentral.amazon.de/gp/help/help.html/?itemID=200612770&ref_=revecalc",
        "FR": "https://sellercentral.amazon.fr/gp/help/help.html/?itemID=200612770&ref_=revecalc",
        "IT": "https://sellercentral.amazon.it/gp/help/help.html/?itemID=200612770&ref_=revecalc",
        "ES": "https://sellercentral.amazon.es/gp/help/help.html/?itemID=200612770&ref_=revecalc",
        "IN": "https://sellercentral.amazon.in/gp/help/help.html/?itemID=200612770&ref_=revecalc",
        "AE": "https://sellercentral.amazon.ae/gp/help/help.html/?itemID=200612770&ref_=revecalc",
        "TR": "https://sellercentral.amazon.com.tr/gp/help/help.html/?itemID=200612770&ref_=revecalc",
        "SA": "https://sellercentral.amazon.sa/gp/help/help.html/?itemID=200612770&ref_=revecalc",
        "NL": "https://sellercentral.amazon.nl/gp/help/help.html/?itemID=200612770&ref_=revecalc",
        "SE": "https://sellercentral.amazon.se/gp/help/help.html/?itemID=200612770&ref_=revecalc",
        "PL": "https://sellercentral.amazon.pl/gp/help/help.html/?itemID=200612770&ref_=revecalc",
        "EG": "https://sellercentral.amazon.eg/gp/help/help.html/?itemID=200612770&ref_=revecalc",
        "BE": "https://sellercentral.amazon.com.be/gp/help/help.html/?itemID=200612770&ref_=revecalc",
        "ZA": "https://sellercentral.amazon.co.za/gp/help/help.html/?itemID=200612770&ref_=revecalc",
        "JP": "https://sellercentral-japan.amazon.com/gp/help/help.html/?itemID=200612770&ref_=revecalc",
        "AU": "https://sellercentral.amazon.com.au/gp/help/help.html/?itemID=200612770&ref_=revecalc",
        "SG": "https://sellercentral.amazon.sg/gp/help/help.html/?itemID=200612770&ref_=revecalc",
    },
    "FBAInboundPlacementFee": {
        "US": "https://sellercentral.amazon.com/help/hub/reference/external/GC3Q44PBK8BXQW3Z",
    },
    "FBAInboundConvenienceFee": {
        // TODO: US should be removed because it actually use FBAInboundPlacementFee.
        "US": "https://sellercentral.amazon.com/help/hub/reference/G200735910?ref_=revecalc",
        "GB": "https://sellercentral.amazon.co.uk/gp/help/help.html/?itemID=G200735910&ref_=revecalc",
        "DE": "https://sellercentral.amazon.de/gp/help/help.html/?itemID=G200735910&ref_=revecalc",
        "FR": "https://sellercentral.amazon.fr/gp/help/help.html/?itemID=G200735910&ref_=revecalc",
        "IT": "https://sellercentral.amazon.it/gp/help/help.html/?itemID=G200735910&ref_=revecalc",
        "ES": "https://sellercentral.amazon.es/gp/help/help.html/?itemID=G200735910&ref_=revecalc"
    },
    "PrepFees": {
        "US": "https://sellercentral.amazon.com/help/hub/reference/G201023020?ref_=revecalc",
        "CA": "https://sellercentral.amazon.ca/gp/help/help.html/?itemID=G201023020&ref_=revecalc",
        "MX": "https://sellercentral.amazon.com.mx/gp/help/help.html/?itemID=G201023020&ref_=revecalc",
        "GB": "https://sellercentral.amazon.co.uk/gp/help/help.html/?itemID=G201023020&ref_=revecalc",
        "DE": "https://sellercentral.amazon.de/gp/help/help.html/?itemID=G201023020&ref_=revecalc",
        "FR": "https://sellercentral.amazon.fr/gp/help/help.html/?itemID=G201023020&ref_=revecalc",
        "IT": "https://sellercentral.amazon.it/gp/help/help.html/?itemID=G201023020&ref_=revecalc",
        "ES": "https://sellercentral.amazon.es/gp/help/help.html/?itemID=G201023020&ref_=revecalc",
        "IN": "https://sellercentral.amazon.in/gp/help/help.html/?itemID=G201023020&ref_=revecalc",
        "TR": "https://sellercentral.amazon.com.tr/gp/help/help.html/?itemID=G201023020&ref_=revecalc",
        "JP": "https://sellercentral-japan.amazon.com/gp/help/help.html/?itemID=G201023020&ref_=revecalc",
        "AU": "https://sellercentral.amazon.com.au/gp/help/help.html/?itemID=G201023020&ref_=revecalc",
        "SG": "https://sellercentral.amazon.sg/gp/help/help.html/?itemID=G201023020&ref_=revecalc",
        "ZA": "https://sellercentral.amazon.co.za/gp/help/help.html/?itemID=G201023020&ref_=revecalc"
    },
    "AgedInventorySurcharge": {
        "US": "https://sellercentral.amazon.com/help/hub/reference/GJQNPA23YWVA4SBD?ref_=revecalc",
        "GB": "https://sellercentral.amazon.co.uk/help/hub/reference/G200684750?ref_=revecalc",
        "DE": "https://sellercentral.amazon.de/help/hub/reference/G200684750?ref_=revecalc",
        "FR": "https://sellercentral.amazon.fr/help/hub/reference/G200684750?ref_=revecalc",
        "IT": "https://sellercentral.amazon.it/help/hub/reference/G200684750?ref_=revecalc",
        "ES": "https://sellercentral.amazon.es/help/hub/reference/G200684750?ref_=revecalc",
        "JP": "https://sellercentral-japan.amazon.com/help/hub/reference/G200684750?ref_=revecalc",
    },
    "SellerFlexFee": {
        "IN": "https://sellercentral.amazon.in/help/hub/reference/G202068010?ref_=revecalc"
    }
}

export const nonLoginFeeHelpPageMap: Record<string, Record<string, string>> = {
    "ReferralFee": {
        "US": "https://sellercentral.amazon.com/gp/help/external/GTG4BAWSY39Z98Z3?ref_=revecalc",
        "CA": "https://sellercentral.amazon.ca/gp/help/external/G200336920?ref_=revecalc",
        "MX": "https://sellercentral.amazon.com.mx/gp/help/external/G200336920?ref_=revecalc",
        "BR": "https://sellercentral.amazon.com.br/gp/help/external/G200336920?ref_=revecalc",
        "GB": "https://sellercentral.amazon.co.uk/gp/help/external/H78LW99F4XF3Z38?ref_=revecalc",
        "DE": "https://sellercentral.amazon.de/gp/help/external/GYND54PM5WB84UM?ref_=revecalc",
        "FR": "https://sellercentral.amazon.fr/gp/help/external/F9K4BWLZXRPC62U?ref_=revecalc",
        "IT": "https://sellercentral.amazon.it/gp/help/external/TM7BFLLKEA8T7C4?ref_=revecalc",
        "ES": "https://sellercentral.amazon.es/gp/help/external/CZC4GX2L32EKP6F?ref_=revecalc",
        "IN": "https://sellercentral.amazon.in/gp/help/external/G200336920?ref_=revecalc",
        "AE": "https://sellercentral.amazon.ae/gp/help/external/G200336920?ref_=revecalc",
        "TR": "https://sellercentral.amazon.com.tr/gp/help/external/G200336920?ref_=revecalc",
        "SA": "https://sellercentral.amazon.sa/gp/help/external/G200336920?ref_=revecalc",
        "NL": "https://sellercentral.amazon.nl/gp/help/external/UMBCNJPHD3UV47Q?ref_=revecalc",
        "SE": "https://sellercentral.amazon.se/gp/help/external/MQ6PTDCN6ZAVA55?ref_=revecalc",
        "PL": "https://sellercentral.amazon.pl/gp/help/external/8DGDDVY6WEJ522N?ref_=revecalc",
        "EG": "https://sellercentral.amazon.eg/gp/help/external/G200336920?ref_=revecalc",
        "BE": "https://sellercentral.amazon.com.be/gp/help/external/GKYSFTZ5R8JMAHNV?ref_=revecalc",
        "ZA": "https://sellercentral.amazon.co.za/gp/help/external/G200336920?ref_=revecalc",
        "JP": "https://sellercentral-japan.amazon.com/gp/help/external/G200336920?ref_=revecalc",
        "AU": "https://sellercentral.amazon.com.au/gp/help/external/G200336920?ref_=revecalc",
        "SG": "https://sellercentral.amazon.sg/gp/help/external/G200336920?ref_=revecalc",
    },
    "FixedClosingFee": {
        "US": "https://sellercentral.amazon.com/gp/help/external/G8TPCFJRDFPKAZ6M?ref_=revecalc",
        "CA": "https://sellercentral.amazon.ca/gp/help/external/G200336920?ref_=revecalc",
        "MX": "https://sellercentral.amazon.com.mx/gp/help/external/G200336920?ref_=revecalc",
        "BR": "https://sellercentral.amazon.com.br/gp/help/external/G200336920?ref_=revecalc",
        "GB": "https://sellercentral.amazon.co.uk/gp/help/external/H78LW99F4XF3Z38?ref_=revecalc",
        "DE": "https://sellercentral.amazon.de/gp/help/external/GYND54PM5WB84UM?ref_=revecalc",
        "FR": "https://sellercentral.amazon.fr/gp/help/external/F9K4BWLZXRPC62U?ref_=revecalc",
        "IT": "https://sellercentral.amazon.it/gp/help/external/TM7BFLLKEA8T7C4?ref_=revecalc",
        "ES": "https://sellercentral.amazon.es/gp/help/external/CZC4GX2L32EKP6F?ref_=revecalc",
        "IN": "https://sellercentral.amazon.in/gp/help/external/G200336920?ref_=revecalc",
        "AE": "https://sellercentral.amazon.ae/gp/help/external/G200336920?ref_=revecalc",
        "TR": "https://sellercentral.amazon.com.tr/gp/help/external/G200336920?ref_=revecalc",
        "SA": "https://sellercentral.amazon.sa/gp/help/external/G200336920?ref_=revecalc",
        "NL": "https://sellercentral.amazon.nl/gp/help/external/UMBCNJPHD3UV47Q?ref_=revecalc",
        "SE": "https://sellercentral.amazon.se/gp/help/external/MQ6PTDCN6ZAVA55?ref_=revecalc",
        "PL": "https://sellercentral.amazon.pl/gp/help/external/8DGDDVY6WEJ522N?ref_=revecalc",
        "EG": "https://sellercentral.amazon.eg/gp/help/external/G200336920?ref_=revecalc",
        "BE": "https://sellercentral.amazon.com.be/gp/help/external/GKYSFTZ5R8JMAHNV?ref_=revecalc",
        "ZA": "https://sellercentral.amazon.co.za/gp/help/external/G200336920?ref_=revecalc",
        "JP": "https://sellercentral-japan.amazon.com/gp/help/external/G200336920?ref_=revecalc",
        "AU": "https://sellercentral.amazon.com.au/gp/help/external/G200336920?ref_=revecalc",
        "SG": "https://sellercentral.amazon.sg/gp/help/external/G200336920?ref_=revecalc",
    },
    "VariableClosingFee": {
        "US": "https://sellercentral.amazon.com/gp/help/external/GKD9U5REK5DKB38Y?ref_=revecalc",
        "CA": "https://sellercentral.amazon.ca/gp/help/external/G200336920?ref_=revecalc",
        "MX": "https://vender.amazon.com.mx/precios?ref_=revecalc#tarifas-por-referencia",
        "BR": "https://sellercentral.amazon.com.br/gp/help/external/G200336920?ref_=revecalc",
        "GB": "https://sellercentral.amazon.co.uk/gp/help/external/H78LW99F4XF3Z38?ref_=revecalc",
        "DE": "https://sellercentral.amazon.de/gp/help/external/GYND54PM5WB84UM?ref_=revecalc",
        "FR": "https://sellercentral.amazon.fr/gp/help/external/F9K4BWLZXRPC62U?ref_=revecalc",
        "IT": "https://sellercentral.amazon.it/gp/help/external/TM7BFLLKEA8T7C4?ref_=revecalc",
        "ES": "https://sellercentral.amazon.es/gp/help/external/CZC4GX2L32EKP6F?ref_=revecalc",
        "IN": "https://sellercentral.amazon.in/gp/help/external/G200336920?ref_=revecalc",
        "AE": "https://sellercentral.amazon.ae/gp/help/external/G201115050?ref_=revecalc",
        "TR": "https://sellercentral.amazon.com.tr/gp/help/external/G201115050?ref_=revecalc",
        "SA": "https://sellercentral.amazon.sa/gp/help/external/201631600?ref_=revecalc",
        "NL": "https://sellercentral.amazon.nl/gp/help/external/UMBCNJPHD3UV47Q?ref_=revecalc",
        "SE": "https://sellercentral.amazon.se/gp/help/external/MQ6PTDCN6ZAVA55?ref_=revecalc",
        "PL": "https://sellercentral.amazon.pl/gp/help/external/8DGDDVY6WEJ522N?ref_=revecalc",
        "EG": "https://sellercentral.amazon.eg/gp/help/external/G200336920?ref_=revecalc",
        "ZA": "https://sellercentral.amazon.co.za/gp/help/external/G200336920?ref_=revecalc",
        "BE": "https://sellercentral.amazon.com.be/gp/help/external/GKYSFTZ5R8JMAHNV?ref_=revecalc",
        "JP": "https://sellercentral-japan.amazon.com/gp/help/external/G200336920?ref_=revecalc",
        "AU": "https://sellercentral.amazon.com.au/gp/help/external/G200336920?ref_=revecalc",
        "SG": "https://sellercentral.amazon.sg/gp/help/external/G200336920?ref_=revecalc",
    },
    "DigitalServicesFee" : {

    },
    "FulfillmentFee": {
        "US": "https://sellercentral.amazon.com/gp/help/external/GPDC3KPYAGDTVDJP?ref_=revecalc",
        "CA": "https://sellercentral.amazon.ca/gp/help/external/G201112670?ref_=revecalc",
        "MX": "https://sellercentral.amazon.com.mx/gp/help/external/G200209150?ref_=revecalc",
        "BR": "https://sellercentral.amazon.com.br/gp/help/external/G200209150?ref_=revecalc",
        "GB": "https://sellercentral.amazon.co.uk/gp/help/external/G200209150?ref_=revecalc",
        "DE": "https://sellercentral.amazon.de/gp/help/external/G200209150?ref_=revecalc",
        "FR": "https://sellercentral.amazon.fr/gp/help/external/G200209150?ref_=revecalc",
        "IT": "https://sellercentral.amazon.it/gp/help/external/G200209150?ref_=revecalc",
        "ES": "https://sellercentral.amazon.es/gp/help/external/G200209150?ref_=revecalc",
        "IN": "https://sellercentral.amazon.in/gp/help/external/G200209150?ref_=revecalc",
        "AE": "https://sellercentral.amazon.ae/gp/help/external/G200209150?ref_=revecalc",
        "TR": "https://sellercentral.amazon.com.tr/gp/help/external/G200209150?ref_=revecalc",
        "SA": "https://sellercentral.amazon.sa/gp/help/external/G200209150?ref_=revecalc",
        "NL": "https://sellercentral.amazon.nl/gp/help/external/G200209150?ref_=revecalc",
        "SE": "https://sellercentral.amazon.se/gp/help/external/G200209150?ref_=revecalc",
        "PL": "https://sellercentral.amazon.pl/gp/help/external/G200209150?ref_=revecalc",
        "EG": "https://sellercentral.amazon.eg/gp/help/external/G200209150?ref_=revecalc",
        "BE": "https://sellercentral.amazon.com.be/gp/help/external/G200209150?ref_=revecalc",
        "ZA": "https://sellercentral.amazon.co.za/gp/help/external/G200209150?ref_=revecalc",
        "JP": "https://sellercentral-japan.amazon.com/gp/help/external/201112670?ref_=revecalc",
        "AU": "https://sellercentral.amazon.com.au/gp/help/external/201112670?ref_=revecalc",
        "SG": "https://sellercentral.amazon.sg/gp/help/external/201112670?ref_=revecalc",
    },
    "LowInventoryLevelSurcharge" : {
        "US": "https://sellercentral.amazon.com/gp/help/external/GV43F6S76Y9DHYRH?ref_=revecalc",
        "CA": "https://sellercentral.amazon.ca/gp/help/external/GV43F6S76Y9DHYRH?ref_=revecalc",
        "DE": "https://sellercentral.amazon.de/gp/help/external/GV43F6S76Y9DHYRH?ref_=revecalc",
        "ES": "https://sellercentral.amazon.es/gp/help/external/GV43F6S76Y9DHYRH?ref_=revecalc",
        "FR": "https://sellercentral.amazon.fr/gp/help/external/GV43F6S76Y9DHYRH?ref_=revecalc",
        "IT": "https://sellercentral.amazon.it/gp/help/external/GV43F6S76Y9DHYRH?ref_=revecalc",
        "JP": "https://sellercentral-japan.amazon.com/gp/help/external/GV43F6S76Y9DHYRH?ref_=revecalc"
    },
    "ImportFees" : {
        // Add SG Help Page in future CR
    },
    "MonthlyStorageFee": {
        "US": "https://sellercentral.amazon.com/gp/help/external/G3EDYEF6KUCFQTNM?ref_=revecalc",
        "CA": "https://sellercentral.amazon.ca/gp/help/external/200612770?ref_=revecalc",
        "MX": "https://sellercentral.amazon.com.mx/gp/help/external/200612770?ref_=revecalc",
        "BR": "https://sellercentral.amazon.com.br/gp/help/external/200612770?ref_=revecalc",
        "GB": "https://sellercentral.amazon.co.uk/gp/help/external/200612770?ref_=revecalc",
        "DE": "https://sellercentral.amazon.de/gp/help/external/200612770?ref_=revecalc",
        "FR": "https://sellercentral.amazon.fr/gp/help/external/200612770?ref_=revecalc",
        "IT": "https://sellercentral.amazon.it/gp/help/external/200612770?ref_=revecalc",
        "ES": "https://sellercentral.amazon.es/gp/help/external/200612770?ref_=revecalc",
        "IN": "https://sellercentral.amazon.in/gp/help/external/200612770?ref_=revecalc",
        "AE": "https://sellercentral.amazon.ae/gp/help/external/200612770?ref_=revecalc",
        "TR": "https://sellercentral.amazon.com.tr/gp/help/external/200612770?ref_=revecalc",
        "SA": "https://sellercentral.amazon.sa/gp/help/external/200612770?ref_=revecalc",
        "NL": "https://sellercentral.amazon.nl/gp/help/external/200612770?ref_=revecalc",
        "SE": "https://sellercentral.amazon.se/gp/help/external/200612770?ref_=revecalc",
        "PL": "https://sellercentral.amazon.pl/gp/help/external/200612770?ref_=revecalc",
        "EG": "https://sellercentral.amazon.eg/gp/help/external/200612770?ref_=revecalc",
        "BE": "https://sellercentral.amazon.com.be/gp/help/external/200612770?ref_=revecalc",
        "ZA": "https://sellercentral.amazon.co.za/gp/help/external/200612770?ref_=revecalc",
        "JP": "https://sellercentral-japan.amazon.com/gp/help/external/200612770?ref_=revecalc",
        "AU": "https://sellercentral.amazon.com.au/gp/help/external/200612770?ref_=revecalc",
        "SG": "https://sellercentral.amazon.sg/gp/help/external/200612770?ref_=revecalc",
    },
    "FBAInboundPlacementFee": {
        "US": "https://sellercentral.amazon.com/help/hub/reference/external/GC3Q44PBK8BXQW3Z",
    },
    "FBAInboundConvenienceFee": {
        // TODO: US should be removed because it actually use FBAInboundPlacementFee
        "US": "https://sellercentral.amazon.com/gp/help/external/G200735910?ref_=revecalc",
        "GB": "https://sellercentral.amazon.co.uk/gp/help/external/GWK3VTXZ9W5LHMEN?ref_=revecalc",
        "DE": "https://sellercentral.amazon.de/gp/help/external/GWK3VTXZ9W5LHMEN?ref_=revecalc",
        "FR": "https://sellercentral.amazon.fr/gp/help/external/GWK3VTXZ9W5LHMEN?ref_=revecalc",
        "IT": "https://sellercentral.amazon.it/gp/help/external/GWK3VTXZ9W5LHMEN?ref_=revecalc",
        "ES": "https://sellercentral.amazon.es/gp/help/external/GWK3VTXZ9W5LHMEN?ref_=revecalc"
    },
    "PrepFees": {
        "US": "https://sellercentral.amazon.com/gp/help/external/G201023020?ref_=revecalc",
        "CA": "https://sellercentral.amazon.ca/gp/help/external/G201023020?ref_=revecalc",
        "MX": "https://sellercentral.amazon.com.mx/gp/help/external/G201023020?ref_=revecalc",
        "GB": "https://sellercentral.amazon.co.uk/gp/help/external/G201023020?ref_=revecalc",
        "DE": "https://sellercentral.amazon.de/gp/help/external/G201023020?ref_=revecalc",
        "FR": "https://sellercentral.amazon.fr/gp/help/external/G201023020?ref_=revecalc",
        "IT": "https://sellercentral.amazon.it/gp/help/external/G201023020?ref_=revecalc",
        "ES": "https://sellercentral.amazon.es/gp/help/external/G201023020?ref_=revecalc",
        "IN": "https://sellercentral.amazon.in/gp/help/external/G201023020?ref_=revecalc",
        "TR": "https://sellercentral.amazon.com.tr/gp/help/external/G201023020?ref_=revecalc",
        "JP": "https://sellercentral-japan.amazon.com/gp/help/external/G201023020?ref_=revecalc",
        "AU": "https://sellercentral.amazon.com.au/gp/help/external/G201023020?ref_=revecalc",
        "SG": "https://sellercentral.amazon.sg/gp/help/external/G201023020?ref_=revecalc",
        "ZA": "https://sellercentral.amazon.co.za/gp/help/external/G201023020?ref_=revecalc"
    }
}

const defaultDimensionUnitAbbr = "cm";
const defaultWeightUnitAbbr = "kg";
const defaultWeightUnit = "kilograms";
const defaultCurrencySymbol = "$";
const defaultCurrencyUnit = "USD";
const defaultLocale = "en_US";

const defaultCountryList = countryMap["USAmazon"];
const allCountryList:Array<string> = Object.values(countryMap).reduce((acc, list) => {
    list.forEach(entry => {
        acc.push(entry);
    })
    return acc;
}, [] as Array<string>);


export function getCountryListConfig(): Array<string> {
    return get(countryMap, "USAmazon", defaultCountryList);
}

export function getAllCountryListConfig(): Array<string> {
    return allCountryList;
}

export function getProgramStoreCountryListConfig(program: string): Array<string> {
    return get(programAmazonStoreMap, program, defaultCountryList);
}

export function getProgramInventoryCountryListConfig(program: string): Array<string> {
    return get(programInventoryMap, program, defaultCountryList);
}

export function getProgramInventoryByCountry(program: string, countryCode: string): string {
    /**
     *  EURF is cross border fulfillment. It is internal name.
     *  In short term solution, hardcode remote marketplace.
     *  Long term solution, request RF team provide API to get remote marketplace.
     *  Use FR as default marketplace to avid CEE issue.
     *  EU4->UK 'FR'
     *  UK->EU4,NL,SE  'GB'
     *  EU4->TR  'FR'
     */
    if (IRCUrlProgramName.includes('EURF') && program === 'EFN') {
        if (countryCode == 'TR' || countryCode === 'GB') {
            return 'FR';
        } else {
            return 'GB';
        }
    }

    const CEECountryCodes: string[] = ['NL', 'SE', 'PL', 'BE'];
    if (CEECountryCodes.includes(countryCode)) {
        return get(programInventoryMap, program, defaultCountryList)[2];
    }

    if(isProgramWithFxRateParam(program)) {
        return get(gsCoreCountryToInventoryMarketplaceMap,countryCode,defaultCountryList)[0];
    }

    return get(programInventoryMap, program, defaultCountryList)[0];
}

export function isCountryValidForProgram(program: string, countryCode: string): boolean {
    const countryArray: Array<string> = get(programInventoryMap, program, defaultCountryList);
    return countryArray.indexOf(countryCode) > -1;
}

export function isFunctionalityAvailableForClientId(clientId: string, functionality: IRCFunctionality): boolean {
    const clientIdArray: Array<string> = get(ircFunctionalityConfigMap, functionality, []);
    return clientIdArray.indexOf(clientId) > -1;
}

export function getHMDId(): string {
    return sellerCentralFeedbackHMDIdMap["prod"]!["USAmazon"]!;
}

export function getProgramBenfit(program: string): Array<string> {
    return get(programBenefitsMap, program, []);
}

export function getProgramName(program: string): string {
    return get(programNameMap, program, "");
}

export function getDimensionUnitListConfig(): Array<string> {
    return [
        "in",
        "cm"
    ];
}

/**
 * The index of this configuration is a dependency in the handleChangeDimensionUnit function of the NewAsinEstimationComponent.tsx
 */
export function getUnitWeightListConfig(): Array<string> {
    return [
        "lb",
        "kg"
    ];
}

export function getDimensionUnitAbbrConfig(countryCode: string): string {
    return get(countryDimensionUnitAbbrMap, countryCode, defaultDimensionUnitAbbr);
}

export function getWeightUnitAbbrConfig(countryCode: string): string {
    return get(countryWeightUnitAbbrMap, countryCode, defaultWeightUnitAbbr);
}

export function getWeightUnitConfig(countryCode: string): string {
    return get(countryWeightUnitMap, countryCode, defaultWeightUnit);
}

export function getCurrencySymbolConfig(countryCode: string): string {
    return get(countryCurrencySymbolMap, countryCode, defaultCurrencySymbol);
}

export function getCurrencyUnitConfig(countryCode: string): string {
    return get(countryCurrencyUnitMap, countryCode, defaultCurrencyUnit);
}

export function getLocaleConfig(countryCode: string): string {
    return get(countryLocaleMap, countryCode, defaultLocale);
}

export function getHelpPageLink(countryCode: string, feeTypeName: string): string {
    if (isLoginMode()) {
        return get(feeHelpPageMap[feeTypeName], countryCode, "/gp/help?ref_=referral");
    }
    return get(nonLoginFeeHelpPageMap[feeTypeName], countryCode, "/gp/help/external?ref_=referral");
}

export function getProgramLink(program: string, marketplace: string): string {
    if (isLoginMode()) {
        const defaultLink = get(loginProgramHelpLinkMap[program], "ALL", "")
        return get(loginProgramHelpLinkMap[program], marketplace, defaultLink);

    } else {
        const defaultLink = get(nonLoginProgramHelpLinkMap[program], "ALL", "")
        return get(nonLoginProgramHelpLinkMap[program], marketplace, defaultLink);
    }
}

export function isProgramWithInventoryStoreParam(program: string): boolean {
    return programWithInventoryAndStoreParam.indexOf(program) >= 0;
}

export function isProgramWithFxRateParam(program: string): boolean {
    return programWithFxRateParam.indexOf(program) >= 0;
}

export function getInventoryMarketplaceBasedOnCountry(countryCode: string) {
    return get(gsCoreCountryToInventoryMarketplaceMap, countryCode, defaultCountryList);
}

export function isProgramWithCeeParam(program: string): boolean {
    return programWithCeeParam.indexOf(program) >= 0;
}

export function getDefaultProgramParam(programs: Array<string>, countryCode: string) {
    let programParamMap: Record<string, ProgramParam> = {};
    programs.forEach(program => {
        let cleanProgramName = getCleanProgramName(program);
        if (isProgramWithInventoryStoreParam(cleanProgramName)) {
            programParamMap[program] = {
                marketplace: countryCode,
                inventoryPlace: getProgramInventoryByCountry(cleanProgramName, countryCode),
                cee: true
            };
        }
        if (isProgramWithFxRateParam(cleanProgramName)) {
            programParamMap[program] = {
                ...programParamMap[program],
                selectedCurrency: getCurrencyUnitConfig(countryCode),
                marketplace: countryCode,
                inventoryMarketplace: getInventoryMarketplaceBasedOnCountry(countryCode)[0],
                isFxRateRequired: true
            }
        }
        if (isIPSEnabled(countryCode, cleanProgramName)) {
            programParamMap[program] = {
                ...programParamMap[program],
                inboundingFeeParam: DEFAULT_INBOUNDING_FEE_PARAM
            }
        }
    })
    return programParamMap;
}

export function getDefaultProgramParamWithInventoryParams(programs: Array<string>, inventoryPlace: string, countryCode: string,
                                                          cee: boolean, inboundingFeeParam?: InboundingFeeParam) {
    let programParamMap: Record<string, ProgramParam> = {};
    programs.forEach(program => {
        let cleanProgramName = getCleanProgramName(program);
        if (isProgramWithInventoryStoreParam(cleanProgramName)) {
            programParamMap[program] = {
                marketplace: countryCode,
                inventoryPlace: isCountryValidForProgram(cleanProgramName, inventoryPlace) ?
                    inventoryPlace : getProgramInventoryByCountry(cleanProgramName, countryCode),
                cee: isProgramWithCeeParam(cleanProgramName) ? cee : undefined
            }
        }
        if (cleanProgramName == "Core" && countryCode == "DE") {
            programParamMap[program] = {
                marketplace: "DE",
                inventoryPlace: "DE",
                cee: cee
            }
        }
        if (isIPSEnabled(countryCode, cleanProgramName)) {
            programParamMap[program] = {
                ...programParamMap[program],
                inboundingFeeParam: inboundingFeeParam ? inboundingFeeParam : DEFAULT_INBOUNDING_FEE_PARAM
            }
        }
    })

    return programParamMap;
}

export const countryDefaultCategoryTRexIdMap: Record<string, number> = {
    "US": 10028,
    "CA": 10326,
    "MX": 10621,
    "BR": 10935,
    "GB": 12143,
    "DE": 12442,
    "FR": 12742,
    "IT": 13042,
    "ES": 13342,
    "NL": 13630,
    "TR": 13922,
    "AE": 14238,
    "SA": 14546,
    "SE": 14838,
    "PL": 15136,
    "IN": 15538,
    "EG": 15740,
    "JP": 11238,
    "AU": 11532,
    "SG": 11834
};


export const weightUnitList: string[] = [
    "pounds",
    "kilograms"
]

export const dimensionUnitList: string[] = [
    "centimeters",
    "inches"
]

export const defaultCountryCode = "US";

export const IndiaSpecialFeeCategoryTRexIdMap: Record<string, string> = {
    "Apparel Accessories": "15433",
    "Innerwear": "15434",
    "Eyewear": "15436",
    "Sleepwear": "15435",
    "Handbags": "15441",
    "Small Appliances": "15456",
    "Electronics Storage Devices": "15501",
    "Electronic Devices": "15502",
    "PC components": "15504",
    "Tablets": "15529"
}

export const URLToCountryCodeMap: Record<string, Record<string, string>> = {
    "test": {
        "rainier-m1k.integ.amazon.com": "US",
        "integ.sellercentral.amazon.dev": "US",
        "sellercentral-us-beta.integ.amazon.com": "US",
        "rainier-ca.integ.amazon.com": "CA",
        "rainier-mx.integ.amazon.com": "MX",
        "rainier-br.integ.amazon.com": "BR",
        "rainier-uk.integ.amazon.com": "GB",
        "rainier-eu.integ.amazon.com": "GB",
        "rainier-in.integ.amazon.com": "IN",
        "sellercentral-ae-beta.integ.amazon.com": "AE",
        "sellercentral-mena-beta.integ.amazon.com": "AE",
        "sellercentral-tr-beta.integ.amazon.com": "TR",
        "sellercentral-sa-beta.integ.amazon.com": "SA",
        "sellercentral-nl-beta.integ.amazon.com": "NL",
        "sellercentral-se-beta.integ.amazon.com": "SE",
        "sellercentral-pl-beta.integ.amazon.com": "PL",
        "sellercentral-eg-beta.integ.amazon.com": "EG",
        "sellercentral-be-beta.integ.amazon.com": "BE",
        "sellercentral-za-beta.integ.amazon.com": "ZA",
        "rainier-jp.integ.amazon.com": "JP",
        "sellercentral-au-beta.integ.amazon.com": "AU",
        "sellercentral-sg-beta.integ.amazon.com": "SG",
    },
    "master": {
        "seller-central-master.amazon.com": "US",
        "gamma.sellercentral.amazon.dev": "US",
        "rainier-mx-preprod.amazon.com": "MX",
        "rainier-br-preprod.amazon.com": "BR",
        "seller-central-eu-onebox.amazon.com": "GB",
        "sellercentral-ae-gamma.aka.amazon.com": "AE",
        "sellercentral-mena-gamma.aka.amazon.com": "AE",
        "sellercentral-tr-gamma.aka.amazon.com": "TR",
        "sellercentral-sa-gamma.aka.amazon.com": "SA",
        "sellercentral-nl-gamma.aka.amazon.com": "NL",
        "sellercentral-se-gamma.aka.amazon.com": "SE",
        "sellercentral-pl-gamma.aka.amazon.com": "PL",
        "sellercentral-eg-gamma.aka.amazon.com": "EG",
        "sellercentral-be-gamma.aka.amazon.com": "BE",
        "sellercentral-za-gamma.aka.amazon.com": "ZA",
        "seller-central-jp-onebox.amazon.com": "JP",
        "sellercentral-au-gamma.aka.amazon.com": "AU",
        "sellercentral-sg-gamma.aka.amazon.com": "SG",
    },
    "prod": {
        "sellercentral.amazon.com": "US",
        "sellercentral.amazon.ca": "CA",
        "sellercentral.amazon.com.mx": "MX",
        "sellercentral.amazon.com.br": "BR",
        "sellercentral.amazon.co.uk": "GB",
        "sellercentral-europe.amazon.com": "GB",
        "sellercentral.amazon.de": "DE",
        "sellercentral.amazon.fr": "FR",
        "sellercentral.amazon.it": "IT",
        "sellercentral.amazon.es": "ES",
        "sellercentral.amazon.in": "IN",
        "sellercentral.amazon.ae": "AE",
        "sellercentral-mena.amazon.com": "AE",
        "sellercentral.amazon.com.tr": "TR",
        "sellercentral.amazon.sa": "SA",
        "sellercentral.amazon.nl": "NL",
        "sellercentral.amazon.se": "SE",
        "sellercentral.amazon.pl": "PL",
        "sellercentral.amazon.eg": "EG",
        "sellercentral.amazon.com.be": "BE",
        "sellercentral.amazon.co.za": "ZA",
        "sellercentral-japan.amazon.com": "JP",
        "sellercentral.amazon.co.jp": "JP",
        "sellercentral.amazon.com.au": "AU",
        "sellercentral.amazon.sg": "SG",
    }
}

export function getCurrentCountryCodeByURL(url: string): string {
    return get(URLToCountryCodeMap["prod"]!, url, defaultCountryCode);
}

export const storageSurchargeMarketplace: Set<String> = new Set<String>(["US", "GB", "DE", "FR", "IT", "ES", "CA"])

export function isStorageSurchargeCountry(countryCode: string): boolean {
    return storageSurchargeMarketplace.has(countryCode);
}

export const ipsCountries: Array<string> = ["US"];

export function isIPSCountry(countryCode: string | undefined): boolean {
    if (!countryCode) {
        return false;
    }
    return ipsCountries.includes(countryCode);
}

export const ipsEligibleRemotePrograms: Array<string> = ['NARF'];

export function isIPSRemoteProgram(program: string | undefined): boolean {
    if (!program) {
        return false;
    }
    return ipsEligibleRemotePrograms.includes(program);
}

export function isIPSEnabled(countryCode: string, program: string): boolean {
    // IPS enabled when inventory place in US, so when MP == US or program == NARF, we enable new IPS fee.
    return (isIPSCountry(countryCode) && program === PROGRAM_NAME_OF_FBA) || program === PROGRAM_NAME_OF_NARF;
}

export const ipsCountryLocationsMap: Record<string, Record<InboundingRegions, string>> = {
    "US": {
        [InboundingRegions.EAST]: "RC_Label_EastRegion", [InboundingRegions.CENTRAL]: "RC_Label_CentralRegion",
        [InboundingRegions.WEST]: "RC_Label_WestRegion"
    }
};

export function getIPSLocationsOfCountry(countryCode: string): Record<InboundingRegions, string> | undefined {
    return get(ipsCountryLocationsMap, countryCode, undefined);
}

export const ipsCountryMaxLocationsNum: Record<string, number> = {
    "US": 4 // Should display 4+, but use 4 to calculate total shipment cost.
}

export function getIPSMaxLocationNum(country: string): number {
    return get(ipsCountryMaxLocationsNum, country, 0);
}

export const ipsCountryLocationsNumLimitMap: Record<string, Record<IPSServiceOption, Array<number>>> = {
    // Option: [lower, upper]
    "US": {[IPSServiceOption.PREMIUM]: [1, 1], [IPSServiceOption.DISCOUNTED]: [2, 3], [IPSServiceOption.NO_FEE]: [4, 4]}
};

export function getIPSLocationNumBound(countryCode: string, option: IPSServiceOption): Array<number> {
    // Returns [lower, upper]. If getting Infinity upperbound,
    // caller should know that this is the last option and convert lower bound to {lower_bound}+, e.g. 4+
    const currentCountryConfigs = get(ipsCountryLocationsNumLimitMap, countryCode, []);
    return get(currentCountryConfigs, option, []);
}

export const ipsOptionsToStringMap: Record<IPSServiceOption, string> = {
    [IPSServiceOption.PREMIUM]: "RC_InputLabel_Premium",
    [IPSServiceOption.DISCOUNTED]: "RC_InputLabel_DiscountedServices",
    [IPSServiceOption.NO_FEE]: "RC_InputLabel_NoFee"
}

export function getIPSOptionString(option: IPSServiceOption): string {
    return get(ipsOptionsToStringMap, option, "");
}
export function isNAMarketplace(countryCode: string): boolean {
    const naMarketplaces = countryMap['USAmazon'];
    return naMarketplaces.includes(countryCode);
}

export function getCleanProgramName(indexedProgramName: string): string {
    // Trim the index (if exists) from program name. For example: Core#0 -> Core
    // If not indexed, return the original value.
    return indexedProgramName.split(PROGRAM_INDEX_DELIMITER, 1)[0];
}

export function getIndexedProgramName(cleanProgramName: string, index: number): string {
    // Core -> Core#0
    return cleanProgramName + PROGRAM_INDEX_DELIMITER + index;
}

export const defaultIndexedPrograms = [getIndexedProgramName(PROGRAM_NAME_OF_FBA, 0), getIndexedProgramName(PROGRAM_NAME_OF_MFN, 1)]; // For Indexed Web RC.
